import { type ObjectValuesUnionType } from '../utils/typing';

export const BasketOddsFromContexts = Object.freeze({
  LINE_UP: 'LU',
  IMMERSIVE: 'IMRSV',
  REPEAT_BET: 'REPEAT_BET',
});

export type BasketOddsFromContext = ObjectValuesUnionType<typeof BasketOddsFromContexts>;
